<app-header></app-header>

<section class="container-xxl">
  <!-- BREADCRUMB AREA - STARTS -->
  <div class="breadcrumb-area">
    <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb>
  </div> 
  <!-- BREADCRUMB AREA - ENDS -->
 
  <div class="inner-page">
    <div class="inner-page-details">
      <div class="row">
        <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
          <div [style]="navmenuloadCss">
              <app-plugin-navbar [datacollection]="{data:P_data}" *ngIf="showNavComponent"></app-plugin-navbar>
            </div>
      </div>
      <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
          <!-- INNER CONTENT - STARTS -->
          <div class="inner-page-sidedetails">
            <div class="row">
              <div class="col-lg-12">
                <div id="section-New"></div>
                <div class="inner-banner-image">
                  <div class="image-area">
                    <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image" />
                  </div>
                </div>
                <div class="details">
                  <div class="title d-block d-sm-flex justify-content-between">
                    <h2 class="screen-reader">{{ 'IndependentNonofficialDirectors' | translate }}</h2>
                  </div>
                  <div class="description">
                    <div class="whatsnew">
                      <div class="row">
                        <div class="col-lg-12">
                          <!-- press release section area -->

                          <div class="d-flex justify-content-start flex-wrap whatsnew-box-area"
                            *ngFor="let i=index;let item of mousList | paginate: { id:'pg1',itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords};">
                            <div class="whatsnew-count">
                              <div class="count-box d-flex justify-content-center align-items-center screen-reader">
                                <h2 *ngIf="currentPage==1">{{i+1}}</h2>
                                <h2 *ngIf="currentPage>1">{{(limit*(currentPage-1)) + (i+1)}}</h2>
                              </div>
                            </div>
                            <div class="whatsnew-details font-adjust">
                              <div class="whatsnew-txt">
                                <h4 class="screen-reader">{{ language=='English'?item.title:item.titleInHindi }}</h4>
                              </div>
                              <p class="screen-reader">{{ language=='English'?item.shortDescription:item.shortDescriptionInHindi }}</p>
                              <div class="note-dates d-block d-sm-flex justify-content-between align-items-center">
                                <div class="d-flex align-items-center flex-wrap flex-wrap">
                                  <div class="opening-date font-adjust screen-reader">
                                    <strong class="d-block text-dark">
                                      <span class="me-2">
                                        <i class="bi bi-calendar3 me-1"></i>
                                        {{ item.publishDate | date: 'MMM d, y'}}
                                      </span>
                                    </strong>
                                    <div class="text-muted">
                                      {{ 'PublishDate'| translate }}
                                    </div>
                                  </div> 
                                  <!-- <div class="opening-date" *ngFor="let initem of Files_(item.uploadDocument);">
                                    <strong class="d-block">
                                      <a [href]="backend_url+'storage/app/uploads/'+initem.selectFile" [download]="initem.selectFile" target="_blank" title="{{ initem.fileTitle }}" class="text-success"><span class="me-2"> <i
                                        class="bi bi-download me-1"></i>{{ 'Download' | translate }}</span></a>
                                    </strong>
                                    <span class="labels text-muted">({{ initem.selectFile_details.fileSize }} <span style="text-transform: uppercase;" *ngIf="checkFileType(initem)!==false" [innerHtml]="checkFileType(initem).file"></span>) </span>
                                  </div> -->
                                </div>
                                <div class="d-flex">
                                  
                                </div>
                              </div>
                              <div class="col-md-12 mt-2">
                                <div class="table-responsive font-adjust">
                                  <table class="table table-hover" aria-describedby="tenderTbale">
                                      <thead>
                  <tr>
                      <th class="screen-reader">#</th>
                      <th class="screen-reader">{{ 'DocumentName' | translate}}</th>
                      <th class="text-end screen-reader">{{ 'DocumentSize' | translate}}</th>
                      <th class="text-center screen-reader">{{ 'Download' | translate}}</th>
                  </tr>
                                      </thead>
      <tbody>

          <tr *ngFor="let f of Files_(item.uploadDocument); let x = index;">
              <td class="screen-reader">{{ x+1 }}</td>
              <td class="screen-reader">
                  {{ htmlTag(f.fileTitle)}}
              </td>
              <td class="text-end screen-reader">
                  {{ f.selectFile_details.fileSize }} 
                  <span style="text-transform: uppercase;" *ngIf="checkFileType(f)!==false" [innerHtml]="checkFileType(f).file"></span>
                  || {{f.dtmCreatedOn | date:'MMM d, y'}}
              </td>
              <td class="text-center screen-reader">
                  <strong class="d-block">
                      <a target="_blank" [href]="backend_url+'storage/app/uploads/'+f.selectFile" title="{{ f.fileType}}" class="text-green"  [download]="f.selectFile"><span class="me-2"> 
                        <i class="bi bi-download me-1"></i> </span></a>
                  </strong>
              </td>
          </tr>
          
      </tbody>
                                  </table>
                              </div>
                              </div>
                            </div>
                          </div>
                          <pagination-controls id="pg1" class="text-center screen-reader" (pageChange)="pageChanged($event)"
                            *ngIf="totalRecords > 10"></pagination-controls>
                          <!-- press release section area -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- INNER CONTENT - ENDS -->
        </div>
      </div>
    </div>
  </div>
</section>

<app-clients></app-clients>

<app-footer></app-footer>